import { useT } from "~/util/Lang";
import { getLocList } from "~/util/loc";

export function QuestLocationList(props: {
  startNpcs: {
    locs: {
      name: string;
      locName: string;
    }[];
  }[];
}) {
  const t = useT();
  const locs = new Map<string, { name: string; locName: string }>();
  for (const npc of props.startNpcs) {
    for (const loc of npc.locs) {
      locs.set(loc.locName, { name: loc.name, locName: loc.locName });
    }
  }
  // return <>{Array.from(locs.values()).join(", ")}</>;
  return <>{getLocList(Array.from(locs.values()))}</>;
}
